package org.vreo.devicehub.features.settings.presentation.settings.components

import org.vreo.devicehub.features.core.domain.device.device.anprDeviceSettings.AnprDeviceUpdateReleaseType
import org.vreo.devicehub.features.core.presentation.UiText

import devicehub.composeapp.generated.resources.Res
import devicehub.composeapp.generated.resources.update_release_type_alpha
import devicehub.composeapp.generated.resources.update_release_type_beta
import devicehub.composeapp.generated.resources.update_release_type_release

/**
 * Converts [AnprDeviceUpdateReleaseType] to [UiText].
 */
fun AnprDeviceUpdateReleaseType.toUiText(): UiText {
    val stringRes = when (this) {
        AnprDeviceUpdateReleaseType.ALPHA -> Res.string.update_release_type_alpha
        AnprDeviceUpdateReleaseType.BETA -> Res.string.update_release_type_beta
        AnprDeviceUpdateReleaseType.STABLE -> Res.string.update_release_type_release
    }

    return UiText.StringResourceId(stringRes)
}